"use strict";

var React = require('react');

var _require = require('../contexts/translate-context'),
    useTranslateContext = _require.useTranslateContext;

var Translate = function Translate(_ref) {
  var id = _ref.id,
      children = _ref.children;

  var _useTranslateContext = useTranslateContext(),
      staticTranslations = _useTranslateContext.staticTranslations;

  var index = id ? id : children;
  var translation = staticTranslations && staticTranslations.hasOwnProperty(index) ? staticTranslations[index] : children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, translation);
};

module.exports = Translate;